import React from "react";
import SectionHead from "../components/common/SectionHead";
import MediaCard from "../components/common/MediaCard";
import { projectLinks } from "../components/home/FeaturedWork";
import { ventureLinks } from "../components/home/Ventures";
import { projects, ventures } from "../data/content";

function Work() {
  return (
    <div className="page">
      <div className="container">
        <SectionHead as="h1" eyebrow="Portfolio" title="My Recent Works" />

        <section className="work__block">
          <div className="writing__head">
            <div>
              <h2>My Ventures</h2>
              <p className="lede">Products and businesses I'm building.</p>
            </div>
          </div>

          <div className="card-grid">
            {ventures.map((venture) => (
              <MediaCard
                key={venture.title}
                image={venture.image}
                title={venture.title}
                description={venture.description}
                links={ventureLinks(venture)}
                logo
              />
            ))}
          </div>
        </section>

        <section className="work__block">
          <div className="writing__head">
            <div>
              <h2>My Personal Projects</h2>
              <p className="lede">
                Here are a few projects I've worked on recently.
              </p>
            </div>
          </div>

          <div className="card-grid">
            {projects.map((project) => (
              <MediaCard
                key={project.title}
                image={project.image}
                title={project.title}
                description={project.description}
                links={projectLinks(project)}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default Work;
